import Grid from '@mui/material/Grid'
import { AlarmIcon, CloseIcon } from 'assets/icons'
import IconButton from 'components/buttons/IconButton'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { EventDoc, EventReminder } from 'types/api/changes'

import i18n from 'i18n'
import CustomEventReminderPopup from 'components/popups/eventInfo/CustomEventRecurrencePopup'
import { useState } from 'react'
import { reminderUserTitle } from 'components/popups/eventInfo/AddReminderPopup'

interface RemindersListProps {
  reminders: EventReminder[]
  setReminders: (reminders: EventReminder[]) => void
  event?: EventDoc
}
const humanizeDuration = require('humanize-duration')

export default function RemindersList(props: RemindersListProps) {
  const [showCustom, setShowCustom] = useState<number | string | undefined>(
    undefined
  )

  return (
    <Grid container flexDirection={'column'} display={'flex'}>
      {(props.reminders ?? [])
        ?.sort((a, b) => Number(a.offset) - Number(b.offset))
        ?.map((reminder, index) => {
          const removeReminder = () => {
            props.setReminders(
              props.reminders.filter((rem) => {
                if (reminder.AlertTime) {
                  return rem.AlertTime !== reminder.AlertTime
                }

                return rem.offset !== reminder.offset
              })
            )
            setShowCustom(undefined)
          }

          let duration = ''

          try {
            duration = humanizeDuration(reminder.offset * 1000, {
              language:
                i18n.language.length > 2
                  ? i18n.language.slice(0, 2)
                  : i18n.language
            })
          } catch (error) {
            duration = humanizeDuration(reminder.offset * 1000)
          }

          return (
            <PopupSectionRow
              icon={<AlarmIcon />}
              cursor="default"
              flexGrowForRow={1}
              actionBg
              action={() => {
                if (reminder.AlertTime) setShowCustom(reminder.AlertTime)
                else setShowCustom(reminder.offset)
              }}
              title={
                <CustomEventReminderPopup
                  key={reminder.offset}
                  open={
                    reminder.AlertTime
                      ? showCustom === reminder.AlertTime
                      : showCustom === reminder.offset
                  }
                  setOpen={(b: boolean) => {
                    console.log('setOpen', b)
                    if (!b) setShowCustom(undefined)
                  }}
                  event={props.event}
                  reminders={props.reminders}
                  setReminders={props.setReminders}
                  editingReminder={props.reminders.find((rem) => {
                    if (reminder.AlertTime) {
                      return rem.AlertTime === reminder.AlertTime
                    }

                    return rem.offset === reminder.offset
                  })}
                >
                  <span
                    style={{
                      width: 'fit-content'
                    }}
                  >
                    {reminderUserTitle(reminder, props.event?.AllDay === '1')}
                  </span>
                </CustomEventReminderPopup>
              }
              value={
                <IconButton
                  size="xs"
                  onClick={removeReminder}
                  stopPropagationOnClick
                >
                  <CloseIcon />
                </IconButton>
              }
            />
          )
        })}
    </Grid>
  )
}
